import { IClassname } from '@/lib/shared/model/classname';

export const PetsAllowed = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_604)">
        <path
          d="M3.7959 3.00584L7.75745 1.85572C9.03537 1.47234 10.3133 1.60015 11.5912 2.11132L17.5974 4.66716C18.6197 5.05053 19.0031 6.20065 18.6197 7.22299C18.2363 8.24532 17.0862 8.62867 16.0639 8.2453L11.4634 6.32842"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.62354 8.37346L5.2017 9.90697C6.22404 10.4181 7.37415 10.5459 8.52427 10.2903L11.0801 9.77917C12.1024 9.65138 12.7414 8.62905 12.6136 7.7345C12.4858 6.83996 11.5913 6.20099 10.6968 6.32878L7.37416 6.83994"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3256 18.2463C22.3256 20.9299 21.6867 23.1023 25.137 23.1023C28.5874 23.1023 29.2264 21.6966 27.9485 17.6073C27.0539 15.0515 26.2872 12.1123 21.0477 12.1123C16.9584 12.1123 15.5527 16.2016 15.5527 16.2016L11.4633 17.6073C11.4633 17.6073 9.92982 25.2748 16.9584 24.5081C17.214 25.6582 17.4695 29.2363 17.5973 30.3865"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.3767 27.4469L27.3591 22.9206V22.7686"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_604">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.00976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
